import { useMemo } from 'react';

import { useGetCustomerBusinessUnits } from 'api';

import { useOrganisationId } from 'hooks/context';

type BusinessUnitDisplayProps = {
  businessUnit: string;
  className?: string;
};

export const BusinessUnitDisplay = ({
  businessUnit,
  className
}: BusinessUnitDisplayProps) => {
  const organisationId = useOrganisationId<number>();

  const { data: { data: businessUnits = [] } = {} } =
    useGetCustomerBusinessUnits(organisationId);

  const businessUnitDisplayName = useMemo(() => {
    return businessUnits.find((unit) => unit.uuid === businessUnit)?.name;
  }, [businessUnits, businessUnit]);

  return (
    <span className={className}>
      {businessUnitDisplayName ? businessUnitDisplayName : '...'}
    </span>
  );
};
